import { render, staticRenderFns } from "./VSearch.vue?vue&type=template&id=25125486&scoped=true&"
import script from "./VSearch.vue?vue&type=script&lang=js&"
export * from "./VSearch.vue?vue&type=script&lang=js&"
import style0 from "./VSearch.vue?vue&type=style&index=0&id=25125486&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25125486",
  null
  
)

export default component.exports